import { render, staticRenderFns } from "./RuleGroup.vue?vue&type=template&id=163d81b2"
import script from "./RuleGroup.vue?vue&type=script&lang=js"
export * from "./RuleGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports